import { translate } from "app/filters/i18nFilter";

import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

type ExportToHubSpotDropdownItemProps = {
    isExportEnabled: boolean;
    onClick: (destination: string) => void;
    tooltipDisabledContent?: string;
    isUseLockedIcon?: boolean;
};

const ExportToHubSpotDropdownItem = ({
    isExportEnabled,
    onClick,
    tooltipDisabledContent,
    isUseLockedIcon = true,
}: ExportToHubSpotDropdownItemProps) => {
    const tooltip = tooltipDisabledContent ?? translate("si.contacts_search.action.variant.export_to_crm.disabled");
    return (
        <ExportVariantsDropdownItem
            iconName="hubspot"
            isDisabled={!isExportEnabled}
            isUseLockedIcon={isUseLockedIcon}
            variant="hubspot"
            text={translate("si.contacts_search.action.export.variant.hubspot.text")}
            tooltipDisabledContent={tooltip}
            onClick={() => onClick("hubspot")}
        />
    );
};

export default ExportToHubSpotDropdownItem;
